/**
 * Appends `straightToCheckout=true` so customer-twou's useAutoEnrollment hook
 * knows to fire the `Submitted` conversion event on checkout mount (mirrors
 * CYT: Started on CTA click → Submitted on the next page).
 *
 * Falls back to the raw URL if parsing fails so a malformed commerce URL never
 * blocks the redirect.
 */
export const withStraightToCheckoutFlag = (url: string): string => {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set("straightToCheckout", "true");
    return parsed.toString();
  } catch {
    return url;
  }
};

type ResolveEnrollmentRedirectUrlArgs = {
  directToPayment: boolean;
  straightToCheckout: boolean;
  commerceCoordinatorUrl: string;
  getTrackSelectionFallback: () => string;
};

/**
 * Decides where to send the user after the enrollment API call in `enroll.ts`:
 *  - CYT (track selection) when not going direct to payment.
 *  - Commerce coordinator URL when directToPayment is set.
 *  - Commerce coordinator URL tagged with `straightToCheckout=true` when the
 *    trigger is the STC flow, so checkout can complete the funnel event.
 */
const resolveEnrollmentRedirectUrl = ({
  directToPayment,
  straightToCheckout,
  commerceCoordinatorUrl,
  getTrackSelectionFallback,
}: ResolveEnrollmentRedirectUrlArgs): string => {
  if (!directToPayment) {
    return getTrackSelectionFallback();
  }

  return straightToCheckout
    ? withStraightToCheckoutFlag(commerceCoordinatorUrl)
    : commerceCoordinatorUrl;
};

export default resolveEnrollmentRedirectUrl;
